// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__tcZeO","label":"Completed_label__2td6x"};